import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Dallas = () => {
  useEffect(() => {
    // Update page title and meta tags
    document.title = 'We Buy Valves Dallas | Industrial Equipment Buyers Dallas TX';
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy valves Dallas - Professional valve buyers in Dallas, TX. We purchase surplus valves, Fisher control valves, and instrumentation from Dallas industrial facilities. Fast quotes and competitive pricing.');
    }
    
    // Meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'Dallas valve buyers, Dallas industrial equipment, Fisher valves Dallas, surplus equipment Dallas TX, North Texas buyers');
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/dallas');
    
    // Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Dallas Valve Buyers | ValveSalesSupply' },
      { property: 'og:description', content: 'Professional valve buyers in Dallas, TX. We purchase surplus valves, Fisher control valves, and instrumentation from Dallas industrial facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/dallas' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    // Geo tags for Dallas
    const geoTags = [
      { name: 'geo.position', content: '32.7767;-96.7970' },
      { name: 'geo.placename', content: 'Dallas, Texas' },
      { name: 'geo.region', content: 'US-TX' }
    ];
    
    geoTags.forEach(tag => {
      let geoTag = document.querySelector(`meta[name="${tag.name}"]`);
      if (!geoTag) {
        geoTag = document.createElement('meta');
        geoTag.setAttribute('name', tag.name);
        document.head.appendChild(geoTag);
      }
      geoTag.setAttribute('content', tag.content);
    });
    
    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/dallas/#webpage",
          "url": "https://valvesalessupply.com/dallas",
          "name": "Dallas Valve Buyers - ValveSalesSupply Dallas TX",
          "description": "Professional valve buyers in Dallas, TX. We purchase surplus valves, Fisher control valves, and instrumentation from Dallas industrial facilities. Fast quotes and competitive pricing.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Texas",
                "item": "https://valvesalessupply.com/texas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Dallas",
                "item": "https://valvesalessupply.com/dallas"
              }
            ]
          }
        },
        {
          "@type": "Place",
          "@id": "https://valvesalessupply.com/dallas/#place",
          "name": "Dallas, Texas",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Dallas",
            "addressRegion": "TX",
            "addressCountry": "US",
            "postalCode": "75201"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 32.7767,
            "longitude": -96.7970
          },
          "description": "Major business hub in North Texas with significant industrial and manufacturing operations"
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply Dallas Headquarters",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Dallas",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "telephone": "+1-214-854-5638",
          "email": "dallas@valvesalessupply.com",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 32.7767,
            "longitude": -96.7970
          },
          "serviceArea": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": 32.7767,
              "longitude": -96.7970
            },
            "geoRadius": "100 mi"
          },
          "description": "Professional industrial equipment purchasing services in Dallas, specializing in surplus valves, control valves, and instrumentation from industrial facilities.",
          "knowsAbout": [
            "Industrial Equipment Valuation",
            "Fisher Control Valves",
            "Manufacturing Operations",
            "Industrial Valve Assessment",
            "Process Equipment"
          ],
          "areaServed": [
            "Dallas",
            "Fort Worth",
            "Arlington",
            "Plano",
            "Irving",
            "Garland",
            "Grand Prairie"
          ]
        },
        {
          "@type": "Service",
          "name": "Dallas Industrial Equipment Purchasing",
          "description": "Specialized purchasing of surplus industrial equipment from Dallas-area facilities including valves, instrumentation, and control systems",
          "provider": {
            "@id": "https://valvesalessupply.com/#organization"
          },
          "areaServed": {
            "@type": "Place",
            "name": "Dallas, Texas",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Dallas",
              "addressRegion": "TX",
              "addressCountry": "US"
            }
          }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Do you buy valves from Dallas industrial facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We specialize in purchasing surplus valves, Fisher control valves, and instrumentation from Dallas-area industrial facilities, manufacturing plants, and processing operations. We provide fast 4-6 hour response times and competitive pricing for North Texas operations."
              }
            },
            {
              "@type": "Question",
              "name": "What types of equipment do you buy in Dallas?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase all types of industrial equipment from Dallas facilities including Fisher control valves, gate valves, globe valves, Rosemount transmitters, flow meters, pressure gauges, safety relief valves, actuators, positioners, and complete instrumentation packages from manufacturing and processing plants."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you respond to Dallas facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide 4-6 hour response times for Dallas and North Texas facilities. Our local Dallas team has extensive industrial experience and can quickly evaluate your surplus equipment, provide competitive quotes, and arrange pickup to meet your project timelines."
              }
            },
            {
              "@type": "Question",
              "name": "Do you serve the entire Dallas-Fort Worth area?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We serve all of the Dallas-Fort Worth metroplex including Dallas, Fort Worth, Arlington, Plano, Irving, Garland, and surrounding North Texas communities. We have local teams ready to respond quickly to your equipment purchasing needs."
              }
            },
            {
              "@type": "Question",
              "name": "What brands of valves do you buy in Dallas?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase all major valve brands including Fisher, Masoneilan, Flowserve, Cameron, Emerson, Anderson Greenwood, Crosby, and more. We buy both control valves and manual valves in all sizes and pressure ratings from Dallas industrial facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Can you handle equipment removals from Dallas facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We have the equipment, expertise, and logistics capabilities to handle equipment removals from Dallas-area industrial facilities. We coordinate all aspects including disconnection, rigging, transportation, and site cleanup while maintaining full safety compliance."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const dallasFacilities = [
    { name: 'ExxonMobil Dallas', location: 'Irving', type: 'Corporate HQ' },
    { name: 'Celanese Dallas', location: 'Irving', type: 'Chemical Manufacturing' },
    { name: 'Kimberly-Clark', location: 'Irving', type: 'Manufacturing' },
    { name: 'Texas Instruments', location: 'Dallas', type: 'Electronics Manufacturing' },
    { name: 'AT&T', location: 'Dallas', type: 'Telecommunications' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from Dallas industrial facilities?",
      answer: "Yes! We specialize in purchasing surplus valves, Fisher control valves, and instrumentation from Dallas-area industrial facilities, manufacturing plants, and processing operations. We provide fast 4-6 hour response times and competitive pricing for North Texas operations."
    },
    {
      question: "What types of equipment do you buy in Dallas?",
      answer: "We purchase all types of industrial equipment from Dallas facilities including Fisher control valves, gate valves, globe valves, Rosemount transmitters, flow meters, pressure gauges, safety relief valves, actuators, positioners, and complete instrumentation packages from manufacturing and processing plants."
    },
    {
      question: "How quickly can you respond to Dallas facilities?",
      answer: "We provide 4-6 hour response times for Dallas and North Texas facilities. Our local Dallas team has extensive industrial experience and can quickly evaluate your surplus equipment, provide competitive quotes, and arrange pickup to meet your project timelines."
    },
    {
      question: "Do you serve the entire Dallas-Fort Worth area?",
      answer: "Absolutely! We serve all of the Dallas-Fort Worth metroplex including Dallas, Fort Worth, Arlington, Plano, Irving, Garland, and surrounding North Texas communities. We have local teams ready to respond quickly to your equipment purchasing needs."
    },
    {
      question: "What brands of valves do you buy in Dallas?",
      answer: "We purchase all major valve brands including Fisher, Masoneilan, Flowserve, Cameron, Emerson, Anderson Greenwood, Crosby, and more. We buy both control valves and manual valves in all sizes and pressure ratings from Dallas industrial facilities."
    },
    {
      question: "Can you handle equipment removals from Dallas facilities?",
      answer: "Yes! We have the equipment, expertise, and logistics capabilities to handle equipment removals from Dallas-area industrial facilities. We coordinate all aspects including disconnection, rigging, transportation, and site cleanup while maintaining full safety compliance."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-teal-500/20 text-teal-300 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-map-pin-line"></i>
              <span>Serving Dallas-Fort Worth Metroplex</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              We Buy Valves Dallas
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
              Dallas's premier buyer of used process equipment, valves, and instrumentation. 
              Top dollar paid with fast, professional service.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="tel:2148545638"
                className="inline-flex items-center gap-2 bg-teal-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Call (214) 854-5638
              </a>
              <a
                href="mailto:valvesalessupply@gmail.com"
                className="inline-flex items-center gap-2 bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line text-xl"></i>
                Request Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Top Brands We Purchase in Dallas */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Industrial Equipment Brands We Buy in Dallas
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Purchasing premium used equipment from Dallas-Fort Worth's industrial sector. 
              We pay top prices for quality brands.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {/* Control Valves */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-settings-4-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Control Valves Dallas</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Fisher Control Valves</strong> - All models and sizes</p>
                <p className="text-gray-700"><strong>Masoneilan Valves Dallas</strong> - Control and safety valves</p>
                <p className="text-gray-700"><strong>Valtek Severe Service</strong> - High-performance valves</p>
                <p className="text-gray-700"><strong>Q-Check Valves</strong> - Check and control valves</p>
                <p className="text-gray-700">Flowseal, Centerline, Relief Valves, WKM, Durco, Edwards</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Get Valve Quote <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Process Instrumentation */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-line-chart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Process Instrumentation</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Rosemount Dallas</strong> - Transmitters, sensors, analyzers</p>
                <p className="text-gray-700"><strong>Foxboro Equipment</strong> - Controllers, transmitters, recorders</p>
                <p className="text-gray-700"><strong>Fisher Instruments</strong> - Complete instrumentation line</p>
                <p className="text-gray-700"><strong>Barton Differential</strong> - Pressure instruments</p>
                <p className="text-gray-700">Taylor Instruments</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Instruments <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Valve Automation */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-robot-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Valve Automation</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Limitorque Dallas</strong> - Electric valve actuators</p>
                <p className="text-gray-700"><strong>Fisher Actuators</strong> - Pneumatic and electric</p>
                <p className="text-gray-700"><strong>Bettis Actuators</strong> - Rack & pinion, scotch yoke</p>
                <p className="text-gray-700"><strong>Fisher Positioners</strong> - DVC6000, 3582, 4150</p>
                <p className="text-gray-700">Foxboro, Masoneilan, Valtek Positioners</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Automation <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Regulators & Controllers */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-speed-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Regulators & Controllers</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Fisher Regulators Dallas</strong> - Pressure regulators, relief valves</p>
                <p className="text-gray-700"><strong>Conoflow Regulators</strong> - Precision control</p>
                <p className="text-gray-700"><strong>Control Air</strong> - Pneumatic controllers</p>
                <p className="text-gray-700"><strong>Fisher Controllers</strong> - Process controllers</p>
                <p className="text-gray-700">Q-Check, Valtek Controllers</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Get Controller Quote <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Tube Fittings */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-git-branch-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Tube Fittings & Manifolds</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Swagelok Dallas</strong> - Tube fittings, valves, regulators</p>
                <p className="text-gray-700"><strong>Parker Fittings</strong> - Instrumentation fittings</p>
                <p className="text-gray-700"><strong>Anderson Greenwood</strong> - Manifold systems</p>
                <p className="text-gray-700"><strong>Hoke Fittings</strong> - High-pressure connections</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Fittings <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* Pressure & Temperature */}
            <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-dashboard-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Pressure & Temperature</h3>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>WIKA Dallas</strong> - Gauges, transmitters, sensors</p>
                <p className="text-gray-700"><strong>All Temp Sensors</strong> - RTDs, thermocouples, thermowells</p>
                <p className="text-gray-700"><strong>OCI Temperature</strong> - Industrial sensors</p>
                <p className="text-gray-700"><strong>MCDaniel Gauges</strong> - Pressure measurement</p>
              </div>
              <a href="/contact" className="text-teal-600 font-semibold hover:text-teal-700 inline-flex items-center gap-2">
                Sell Gauges <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl p-8 text-center text-white">
            <h3 className="text-2xl font-bold mb-4">Selling Equipment in the Dallas-Fort Worth Area?</h3>
            <p className="text-lg mb-6 opacity-90">
              We purchase surplus, used, and excess industrial equipment from facilities across the DFW metroplex. 
              Fast quotes and immediate payment available.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="tel:2148545638"
                className="inline-flex items-center gap-2 bg-white text-teal-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                (214) 854-5638
              </a>
              <a
                href="mailto:valvesalessupply@gmail.com"
                className="inline-flex items-center gap-2 bg-teal-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                valvesalessupply@gmail.com
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Dallas Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">DALLAS VALVE BUYERS - NORTH TEXAS HEADQUARTERS</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Dallas is a major business and industrial hub in North Texas. As experienced 
                <strong className="text-[#1B3A5F]"> Dallas valve buyers</strong> and 
                <strong className="text-[#1B3A5F]"> North Texas equipment buyers</strong>, we specialize in 
                purchasing surplus equipment from industrial facilities and manufacturing plants.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We buy <strong className="text-[#1B3A5F]">Fisher control valves Dallas</strong>, 
                surplus gate valves, Rosemount transmitters, and industrial equipment from 
                manufacturing facilities throughout the Dallas-Fort Worth metroplex.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">1000+</div>
                  <div className="text-gray-600">Industrial Sites</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">4-6 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">24/7</div>
                  <div className="text-gray-600">Service</div>
                </div>
              </div>

              <div className="bg-[#F5F7FA] rounded-lg p-4">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Related Texas Markets:</h4>
                <div className="flex flex-wrap gap-2">
                  <Link to="/houston" className="text-[#1B3A5F] hover:underline">Houston</Link>
                  <span className="text-gray-400">•</span>
                  <Link to="/san-antonio" className="text-[#1B3A5F] hover:underline">San Antonio</Link>
                  <span className="text-gray-400">•</span>
                  <Link to="/texas" className="text-[#1B3A5F] hover:underline">All Texas Cities</Link>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">MAJOR DALLAS FACILITIES</h3>
              <div className="space-y-4">
                {dallasFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.location}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">{facility.type}</div>
                      <div className="text-gray-600 text-sm">Industry</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment We Buy */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SELL VALVES DALLAS - WE PAY TOP DOLLAR</h2>
            <p className="text-gray-600 text-xl">Professional equipment buyers serving North Texas</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                category: 'Industrial Valves Dallas',
                brands: ['Fisher', 'Masoneilan', 'Flowserve', 'Cameron'],
                types: ['Control Valves', 'Gate Valves', 'Globe Valves', 'Check Valves']
              },
              {
                category: 'Process Instrumentation',
                brands: ['Rosemount', 'Emerson', 'Honeywell', 'ABB'],
                types: ['Transmitters', 'Controllers', 'Analyzers', 'Flow Meters']
              },
              {
                category: 'Safety Systems Dallas',
                brands: ['Anderson Greenwood', 'Crosby', 'Consolidated', 'Farris'],
                types: ['Relief Valves', 'Safety Valves', 'Rupture Discs', 'Regulators']
              }
            ].map((equipment, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">{equipment.category}</h3>
                
                <div className="mb-6">
                  <h4 className="text-gray-800 font-bold mb-3">Top Brands We Buy:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {equipment.brands.map((brand, brandIndex) => (
                      <div key={brandIndex} className="bg-[#1B3A5F]/10 text-[#1B3A5F] px-3 py-2 rounded-lg text-sm font-medium text-center">
                        {brand}
                      </div>
                    ))}
                  </div>
                </div>
                
                <div>
                  <h4 className="text-gray-800 font-bold mb-3">Equipment Types:</h4>
                  <div className="space-y-2">
                    {equipment.types.map((type, typeIndex) => (
                      <div key={typeIndex} className="flex items-center">
                        <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                        <span className="text-gray-600">{type}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves Dallas */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES DALLAS</h2>
            <p className="text-gray-600 text-xl">Dallas-Fort Worth's premier surplus valve buyers</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">DALLAS SURPLUS VALVE SPECIALISTS</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                As <strong className="text-[#1B3A5F]">Dallas-Fort Worth's leading surplus valve buyers</strong>, 
                we specialize in purchasing quality used valves from North Texas manufacturing and industrial 
                facilities. Our headquarters location in Dallas gives us the fastest response times and 
                highest competitive pricing in the DFW metroplex.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Manufacturing Plant Valves',
                    description: 'Fisher, Masoneilan control valves from DFW industrial facilities',
                    count: '200+ Units',
                    icon: 'ri-building-4-line'
                  },
                  {
                    type: 'Process Control Valves',
                    description: 'Gate and globe valves from Dallas manufacturing operations',
                    count: '300+ Units',
                    icon: 'ri-settings-3-line'
                  },
                  {
                    type: 'Utility Plant Valves',
                    description: 'Ball valves and check valves from North Texas utilities',
                    count: '150+ Units',
                    icon: 'ri-flashlight-line'
                  },
                  {
                    type: 'Safety Equipment',
                    description: 'Relief valves and safety systems from Dallas area plants',
                    count: '100+ Units',
                    icon: 'ri-shield-check-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="bg-[#F5F7FA] rounded-lg p-4">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4">
                        <i className={`${valve.icon} text-white text-xl`}></i>
                      </div>
                      <div className="flex-1">
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="text-[#1B3A5F] font-bold text-lg">{valve.type}</h4>
                          <span className="text-[#1B3A5F] text-sm font-semibold">{valve.count}</span>
                        </div>
                        <p className="text-gray-600 text-sm">{valve.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-gradient-to-r from-[#1B3A5F] to-[#2B5F8F] rounded-lg p-6 text-white">
                <h4 className="font-bold mb-3">Dallas Headquarters Advantage:</h4>
                <div className="grid md:grid-cols-2 gap-3">
                  <div className="flex items-center">
                    <i className="ri-time-line mr-3"></i>
                    <span>4-6 hour response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line mr-3"></i>
                    <span>Highest DFW prices</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line mr-3"></i>
                    <span>Local logistics</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-building-line mr-3"></i>
                    <span>HQ operations</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/809423ee166d182a7c0ec96e84367acb.jpg')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">North Texas Industrial Grade</h3>
                  <p>Premium surplus valves from Dallas-Fort Worth manufacturing hub</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">DALLAS VALVE BUYERS - FREQUENTLY ASKED QUESTIONS</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment in Dallas</p>
          </div>
          
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-600 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">DALLAS VALVE BUYERS - CALL TODAY</h2>
            <p className="text-gray-200 text-xl">Fast quotes for North Texas equipment</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">DALLAS HEADQUARTERS</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">214-854-5638</div>
                    <div className="text-gray-600">Dallas Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">dallas@valvesalessupply.com</div>
                    <div className="text-gray-600">Equipment Lists & Photos</div>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-time-line text-[#1B3A5F] text-xl mr-4 mt-1"></i>
                  <div>
                    <div className="font-bold">4-6 Hour Response</div>
                    <div className="text-gray-600">North Texas Coverage</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-4">
                <h4 className="text-[#1B3A5F] font-bold mb-2">North Texas Manager</h4>
                <p className="text-gray-600">Mark Driver - Industrial specialist</p>
              </div>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">DALLAS ADVANTAGE</h3>
              <div className="space-y-4">
                {[
                  'Highest valve prices in North Texas',
                  'Fastest 4-6 hour response times',
                  'Expert industrial experience',
                  'Complete regulatory compliance',
                  'Local Dallas team with industry knowledge',
                  'DFW metroplex coverage'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <a
                  href="tel:214-854-5638"
                  className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 inline-flex items-center whitespace-nowrap"
                >
                  CALL: 214-854-5638
                  <i className="ri-phone-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Dallas;
